import React, { useRef, useEffect } from "react";
import styles from "./RichTextEditor.module.scss";

interface Props {
  value: string;
  onChange: (v: string) => void;
}

const RichTextEditor: React.FC<Props> = ({ value, onChange }) => {
  const editorRef = useRef<HTMLDivElement>(null);

  const exec = (cmd: string, val?: string) => {
    document.execCommand(cmd, false, val);
    if (editorRef.current) {
      onChange(editorRef.current.innerHTML);
    }
  };

  useEffect(() => {
    if (editorRef.current && editorRef.current.innerHTML !== value) {
      editorRef.current.innerHTML = value;
    }
  }, [value]);

  return (
    <div className={styles.editorWrapper}>

      <div className={styles.toolbar}>
        <select
          onChange={(e) => exec("formatBlock", e.target.value)}
          className={styles.select}
        >
          <option value="p">Normal</option>
          <option value="h1">H1</option>
          <option value="h2">H2</option>
          <option value="h3">H3</option>
        </select>

        <button onMouseDown={(e) => { e.preventDefault(); exec("bold"); }}>
          <b>B</b>
        </button>

        <button onMouseDown={(e) => { e.preventDefault(); exec("italic"); }}>
          <i>I</i>
        </button>

        <button onMouseDown={(e) => { e.preventDefault(); exec("underline"); }}>
          <u>U</u>
        </button>

        <button onMouseDown={(e) => { e.preventDefault(); exec("insertUnorderedList"); }}>
          ≡
        </button>

        <button onMouseDown={(e) => { e.preventDefault(); exec("insertOrderedList"); }}>
          1.
        </button>

        <button onMouseDown={(e) => { e.preventDefault(); exec("formatBlock", "blockquote"); }}>
          "
        </button>

        <button
          onMouseDown={(e) => {
            e.preventDefault();
            const url = prompt("Enter URL:");
            if (url) exec("createLink", url);
          }}
        >
          🔗
        </button>

        <button onMouseDown={(e) => { e.preventDefault(); exec("formatBlock", "pre"); }}>
          {"</>"}
        </button>
      </div>

      <div
        ref={editorRef}
        contentEditable
        suppressContentEditableWarning
        onInput={() => {
          if (editorRef.current) {
            onChange(editorRef.current.innerHTML);
          }
        }}
        className={styles.editor}
      />
    </div>
  );
};

export default RichTextEditor;